/* Little USA World – Einwegpfand: hält die Pfand-Position im Warenkorb synchron zu den Getränken.
   Daten kommen aus sections/luw-pfand-data.liquid (Metafelder custom.pfand_betrag / custom.pfand_anzahl, Pfand-Artikel "pfand"). */
(function () {
  if (window.__luwPfand) return; window.__luwPfand = true;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var timer = null;

  function isCartMutation(url) { return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || '')); }

  function getData() {
    // Abruf über die Warenkorb-Adresse: die Startseite liegt im Seiten-Cache und lieferte veraltete Warenkorb-Daten
    var url = ROOT + 'cart?sections=luw-pfand-data&_=' + Date.now();
    // ohne Accept: application/json – sonst antwortet /cart mit dem Warenkorb statt mit dem Abschnitt
    return nativeFetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { 'Cache-Control': 'no-cache' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var m = String(j['luw-pfand-data'] || '').match(/<script[^>]*id="luw-pfand-json"[^>]*>([\s\S]*?)<\/script>/);
        return m ? JSON.parse(m[1]) : null;
      });
  }

  function replaceFrom(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = doc.querySelector(selector), dst = document.querySelector(selector);
    if (src && dst) dst.innerHTML = src.innerHTML;
    return !!(src && dst);
  }

  function refreshUI(cart) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.innerHTML = el.classList.contains('cart-count-drawer') ? '(' + cart.item_count + ')' : (cart.item_count > 100 ? '~' : cart.item_count);
    });
    var total = document.querySelector('header-total-price');
    if (total && total.updateTotal) { try { total.updateTotal(cart); } catch (e) {} }
    var requests = [];
    var page = document.getElementById('main-cart-items');
    if (page && page.dataset.id) {
      requests.push(nativeFetch(ROOT + 'cart?section_id=' + encodeURIComponent(page.dataset.id) + '&_=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          // Im Leerzustand auch Summe, Versandfortschritt und Checkout entfernen.
          var selector = cart.item_count === 0 ? '#main-cart-items' : '#main-cart-items .js-contents';
          if (!replaceFrom(html, selector)) { window.location.reload(); return; }
          page.classList.toggle('is-empty', cart.item_count === 0);
          if (cart.item_count > 0) replaceFrom(html, '.cart-info .totals');
        })
        .catch(function () { window.location.reload(); }));
    }
    if (document.getElementById('minicart-form')) {
      // Die Warenkorb-Adresse umgehen den Startseiten-Cache.
      requests.push(nativeFetch(ROOT + 'cart?section_id=minicart-form&_=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.text(); })
        .then(function (html) { replaceFrom(html, '#minicart-form'); })
        .catch(function () {}));
    }
    return Promise.all(requests).then(function () {
      document.querySelectorAll('free-ship-progress-bar').forEach(function (bar) {
        if (bar.init) bar.init(cart.items_subtotal_price);
      });
      arrange(); knoepfe();
    });
  }

  // Pfandangaben je Variante (Cent und Stückzahl), über Abrufe hinweg gemerkt
  var info = {};
  try { info = JSON.parse(sessionStorage.getItem('luwPfandInfo') || '{}'); } catch (e) {}
  function merke(d) {
    (d.items || []).forEach(function (it) { if (!it.deposit) info[it.variant_id] = { c: it.pfand_cents || 0, n: it.pfand_count || 1 }; });
    try { sessionStorage.setItem('luwPfandInfo', JSON.stringify(info)); } catch (e) {}
  }
  function warte(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function warenkorb() {   // verbindliche, nie zwischengespeicherte Mengen
    return nativeFetch(ROOT + 'cart.js?_=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  // Shopify liefert die Abschnittsdaten kurz nach einer Änderung manchmal noch im alten Stand.
  // Mengen kommen deshalb immer aus /cart.js; fehlen für einen Artikel die Pfandangaben, wird kurz gewartet und neu gefragt.
  function hole(versuch) {
    return Promise.all([getData(), warenkorb()]).then(function (res) {
      var d = res[0], cart = res[1];
      if (!d || !d.variants || !cart) return null;
      merke(d);
      var fehlt = cart.items.some(function (it) { return it.handle !== 'pfand' && !(String(it.variant_id) in info); });
      if (fehlt && versuch < 6) return warte(300 + versuch * 250).then(function () { return hole(versuch + 1); });
      if (fehlt) console.warn('[Pfand] Pfandangaben unvollständig, rechne mit bekanntem Stand');
      hatPfand = cart.items.some(function (it) { var p = info[String(it.variant_id)]; return it.handle === 'pfand' || (p && p.c); });
      knoepfe();
      return { variants: d.variants, cart: cart };
    });
  }

  function rechne(x) {
    var need = {}, have = {};
    x.cart.items.forEach(function (it) {
      if (it.handle === 'pfand') { have[it.variant_id] = (have[it.variant_id] || 0) + it.quantity; return; }
      var p = info[String(it.variant_id)];
      if (!p || !p.c) return;
      var v = x.variants[String(p.c)];
      if (!v) { console.warn('[Pfand] keine Pfand-Variante für', p.c, 'Cent'); return; }
      need[v] = (need[v] || 0) + it.quantity * (p.n || 1);
    });
    var updates = {}, changed = false;
    Object.keys(Object.assign({}, need, have)).forEach(function (v) {
      if ((have[v] || 0) !== (need[v] || 0)) { updates[v] = need[v] || 0; changed = true; }
    });
    if (!changed) return Promise.resolve(false);
    return nativeFetch(ROOT + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); }).then(function (cart) { return refreshUI(cart).then(function () { return true; }); });
  }

  // Abgleiche laufen nacheinander; wer sync() aufruft, wartet auf einen vollständigen Durchlauf
  var kette = Promise.resolve();
  function einmal() {
    return hole(0).then(function (x) { return x ? rechne(x) : false; })
      .catch(function (e) { console.warn('[Pfand]', e); return false; });
  }
  function sync() { kette = kette.then(einmal, einmal); return kette; }

  // Pfand-Zeilen kennzeichnen und unter die Artikel schieben (Warenkorb-Seite und Warenkorb-Fenster)
  // Warenkorb-Fenster: Rechnung "3 × €0,25 = €0,75 Pfand" statt Einzelpreis und Mengenfeld
  function calcLine(row) {
    if (!row.classList || !row.classList.contains('cart-item')) return;
    var priceEl = row.querySelector('.minicart__item-price'), qtyEl = row.querySelector('input[name="updates[]"], .quantity-input');
    if (!priceEl || !qtyEl) return;
    var txt = priceEl.textContent.trim(), m = txt.match(/\d[\d.]*(?:,\d+)?|\d+(?:\.\d+)?/);
    var qty = parseInt(qtyEl.value, 10);
    if (!m || !qty) return;
    var raw = m[0], unit = raw.indexOf(',') >= 0 ? parseFloat(raw.replace(/\./g, '').replace(',', '.')) : parseFloat(raw);
    if (isNaN(unit)) return;
    var total = (Math.round(unit * 100) * qty / 100).toFixed(2);
    if (raw.indexOf(',') >= 0) total = total.replace('.', ',');
    var label = qty + ' × ' + txt + ' = ' + txt.replace(raw, total) + ' Pfand';
    var el = row.querySelector('.luw-pfand-calc');
    if (!el) { el = document.createElement('div'); el.className = 'luw-pfand-calc'; priceEl.parentNode.insertBefore(el, priceEl); }
    if (el.textContent !== label) el.textContent = label;
    row.classList.add('luw-pfand-has-calc');
  }

  var arranging = false;
  function arrange() {
    if (arranging) return; arranging = true;
    try {
      var rows = [];
      document.querySelectorAll('a[href*="/products/pfand"]').forEach(function (a) {
        var row = a.closest('tr, .cart-item, li');
        if (row && row.closest('cart-items, cart-drawer-items, #minicart-form, #main-cart-items') && rows.indexOf(row) < 0) rows.push(row);
      });
      // Pfand-Zeilen nur optisch nach unten (CSS order), nie im DOM verschieben: das Warenkorb-Formular schickt
      // "updates[]" in DOM-Reihenfolge – verschobene Zeilen vertauschten beim Klick auf "Zur Kasse" die Mengen.
      rows.forEach(function (row) {
        row.setAttribute('data-luw-pfand', '');
        calcLine(row);
      });
    } catch (e) {}
    arranging = false;
  }
  // Pfandhinweis am Preis beim Wechsel der Variante (Einzeln / 12er-Pack) mitziehen
  function pfandHinweis() {
    var feld = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = new URLSearchParams(location.search).get('variant') || (feld && feld.value);
    if (!id) return;
    document.querySelectorAll('.pfand-hint[data-luw-pfand-map]').forEach(function (el) {
      try { var m = JSON.parse(el.getAttribute('data-luw-pfand-map')); if (m[id] && el.textContent !== m[id]) el.textContent = m[id]; } catch (e) {}
    });
  }
  document.addEventListener('change', function () { setTimeout(pfandHinweis, 150); setTimeout(pfandHinweis, 600); }, true);

  // Knopf "Pfand neu berechnen" über "Zur Kasse" (Warenkorb-Seite und -Fenster), nur wenn Getränke oder Pfand im Warenkorb sind.
  // Rückfall, falls der automatische Abgleich einmal nicht greift; die Checkout-Prüfung (App "LUW Pfand-Prüfung") schickt Kunden hierher.
  var hatPfand = false;
  function knoepfe() {
    document.querySelectorAll('[name="checkout"]').forEach(function (co) {
      var b = co.parentNode && co.parentNode.querySelector(':scope > .luw-pfand-neu');
      if (!b) {
        b = document.createElement('button');
        b.type = 'button'; b.className = 'luw-pfand-neu'; b.textContent = 'Pfand neu berechnen';
        b.addEventListener('click', neuBerechnen);
        co.parentNode.insertBefore(b, co);
      }
      b.hidden = !hatPfand;
    });
  }
  function neuBerechnen(ev) {
    var b = ev.currentTarget; if (b.disabled) return;
    b.disabled = true; b.textContent = 'Pfand wird berechnet …';
    info = {}; try { sessionStorage.removeItem('luwPfandInfo'); } catch (e) {}
    sync().then(function () {
      b.textContent = 'Pfand ist aktuell ✓';
      if (document.getElementById('main-cart-items')) setTimeout(function () { window.location.reload(); }, 600);
      else setTimeout(function () { b.disabled = false; b.textContent = 'Pfand neu berechnen'; }, 2500);
    });
  }

  var arrangeTimer = null;
  new MutationObserver(function () { clearTimeout(arrangeTimer); arrangeTimer = setTimeout(function () { arrange(); pfandHinweis(); knoepfe(); }, 60); })
    .observe(document.documentElement, { childList: true, subtree: true });

  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 250); }

  // Warenkorb-Änderungen des Themes mitbekommen (fetch + XHR)
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (isCartMutation(url)) p.then(schedule, function () {});
    return p;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    var self = this;
    this.addEventListener('load', function () { if (isCartMutation(url)) schedule(); });
    return xhrOpen.apply(self, arguments);
  };

  // Vor dem Gang zur Kasse noch einmal abgleichen
  document.addEventListener('click', function (ev) {
    var el = ev.target.closest && ev.target.closest('[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!el || el.__luwPfandOk) return;
    ev.preventDefault(); ev.stopPropagation();
    sync().then(function () { el.__luwPfandOk = true; el.click(); setTimeout(function () { el.__luwPfandOk = false; }, 2000); });
  }, true);

  function start() { arrange(); sync(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
})();
